import { store } from "@/store";

export const expenseStore = {
  namespaced: true,
  state: () => ({
    all: "",
    lastTen: "",
    lastRecord: "",
    type: "expense",
    lastRecordedTrip: {},
    actionSuccessMsg: "",
    actionErrorMsg: ""
  }),
  getters: {
    getLastOdo: state => {
      return state.all.length > 0 ? state.all[0].odometer : 0;
    }
  },
  mutations: {
    //save records
    save(state, formData) {
      store.state.database.put(formData, function callback(err) {
        if (err) {
          state.actionErrorMsg = "failedSave";
          //console.log("saving failed");
          return false;
        }
        state.actionSuccessMsg = "successSave";
      });
    },
    getAllExpenses(state) {
      store.state.database
        .find({
          selector: { type: state.type, _id: { $exists: true }, status: 0 },
          sort: ["_id"]
        })
        .then(result => {
          state.all = result.docs.length > 0 ? result.docs.reverse() : [];
        })
        .catch(function(err) {
          console.log(err);
        });
    },

    getLastTripOdo(state, car) {
      store.state.database
        .find({
          selector: {
            type: "trip",
            _id: { $exists: true },
            is_deleted: false,
            vehicle_pouch_id: car
          },
          sort: ["_id"]
        })
        .then(result => {
          state.lastRecordedTrip = result.docs.reverse()[0];
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    //set record for deletion
    setRecordForDeletion(state, doc) {
      store.commit("expense/save", doc);
    },
    clearMes(state) {
      setTimeout(() => {
        state.actionSuccessMsg = "";
        state.actionErrorMsg = "";
      }, 2000);
      return true;
    }
  },
  actions: {
    getExpensesAction({ commit, rootState }) {
      commit("getAllExpenses", rootState);
    },
    getLastTripAction({ commit }, car) {
      commit("getLastTripOdo", car);
    }
  }
};
